export default {
  name: 'KnFormGroupActions',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
